import { render } from "./DateForm.vue?vue&type=template&id=8b5030b6"
import script from "./DateForm.vue?vue&type=script&lang=js"
export * from "./DateForm.vue?vue&type=script&lang=js"

import "./DateForm.vue?vue&type=style&index=0&id=8b5030b6&lang=css"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__